import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import useTranslations from '../../hooks/useTranslations';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import HeroSection from '../../components/HomeComponents/HeroSection';
import contacts from '../../config/contacts';
import '../../styles/homeDelvante.css';

gsap.registerPlugin(ScrollTrigger);

/* ═══════════════════════════════════════════
   SVG ICONS — no emojis, only SVGs
   ═══════════════════════════════════════════ */

/* Intent card icons */
const IconSunset = () => (
  <svg width="36" height="36" viewBox="0 0 48 48" fill="none" stroke="#e8dfd0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="24" cy="16" r="6"/><line x1="24" y1="4" x2="24" y2="10"/><line x1="14" y1="16" x2="12" y2="16"/><line x1="34" y1="16" x2="36" y2="16"/>
    <line x1="18.3" y1="10.3" x2="15" y2="7"/><line x1="29.7" y1="10.3" x2="33" y2="7"/>
    <path d="M4 26h40"/><path d="M8 32c0-8.8 7.2-16 16-16s16 7.2 16 16"/>
    <line x1="12" y1="38" x2="36" y2="38"/><line x1="16" y1="42" x2="32" y2="42"/>
  </svg>
);
const IconFamily = () => (
  <svg width="36" height="36" viewBox="0 0 48 48" fill="none" stroke="#e8dfd0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="14" r="5"/><path d="M6 36c0-6.6 5.4-12 12-12s12 5.4 12 12"/>
    <circle cx="34" cy="10" r="3.5"/><path d="M28 28c0-3.3 2.7-6 6-6s6 2.7 6 6"/>
    <line x1="24" y1="24" x2="24" y2="44"/><line x1="24" y1="28" x2="14" y2="38"/><line x1="24" y1="28" x2="34" y2="38"/>
  </svg>
);
const IconGraduation = () => (
  <svg width="36" height="36" viewBox="0 0 48 48" fill="none" stroke="#e8dfd0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 18L24 8l20 10-20 10L4 18z"/><path d="M4 18v14"/><path d="M34 22v8c0 2.2-4.5 4-10 4s-10-1.8-10-4v-8"/>
    <polyline points="14,28 14,38 24,42 34,38 34,28"/>
  </svg>
);
const IconLaptop = () => (
  <svg width="36" height="36" viewBox="0 0 48 48" fill="none" stroke="#e8dfd0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="6" y="10" width="36" height="22" rx="2"/><line x1="6" y1="28" x2="42" y2="28"/>
    <path d="M2 36h44M14 36l2 4h16l2-4"/>
    <circle cx="24" cy="16" r="4"/><path d="M24 20v4"/><line x1="30" y1="12" x2="36" y2="12"/><line x1="30" y1="15" x2="34" y2="15"/>
  </svg>
);
const IconChart = () => (
  <svg width="36" height="36" viewBox="0 0 48 48" fill="none" stroke="#e8dfd0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="6" y1="38" x2="42" y2="38"/><line x1="8" y1="38" x2="8" y2="8"/><line x1="42" y1="38" x2="42" y2="14"/>
    <polyline points="8,28 16,16 24,22 32,8 42,12"/><polyline points="32,4 32,8 36,8"/>
  </svg>
);
const IconEU = () => (
  <svg width="36" height="36" viewBox="0 0 48 48" fill="none" stroke="#e8dfd0" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="24" cy="24" r="18"/>
    <polygon points="24,6 26.5,16.5 24,14.5 21.5,16.5" fill="#e8dfd0" stroke="none" opacity="0.7"/>
    <polygon points="39,18 32,25.5 41,25.5" fill="#e8dfd0" stroke="none" opacity="0.7"/>
    <polygon points="39,30 32,22.5 41,22.5" fill="#e8dfd0" stroke="none" opacity="0.7"/>
    <polygon points="24,42 26.5,31.5 24,33.5 21.5,31.5" fill="#e8dfd0" stroke="none" opacity="0.7"/>
    <polygon points="9,30 16,22.5 7,22.5" fill="#e8dfd0" stroke="none" opacity="0.7"/>
    <polygon points="9,18 16,25.5 7,25.5" fill="#e8dfd0" stroke="none" opacity="0.7"/>
  </svg>
);
const IconMap = () => (
  <svg width="36" height="36" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="4,8 16,4 32,8 44,4 44,40 32,44 16,40 4,44"/><line x1="16" y1="4" x2="16" y2="40"/><line x1="32" y1="8" x2="32" y2="44"/>
  </svg>
);

/* Country flag SVGs */
const FlagIT = () => (<svg width="36" height="24" viewBox="0 0 36 24"><rect width="12" height="24" fill="#009246"/><rect x="12" width="12" height="24" fill="#fff"/><rect x="24" width="12" height="24" fill="#ce2b37"/></svg>);
const FlagGR = () => (<svg width="36" height="24" viewBox="0 0 36 24"><rect width="36" height="24" fill="#0d5eaf"/><rect y="0" width="36" height="4" fill="#fff"/><rect y="8" width="36" height="4" fill="#fff"/><rect y="16" width="36" height="4" fill="#fff"/><rect y="20" width="36" height="4" fill="#fff"/><rect width="14" height="10" fill="#0d5eaf"/><rect x="5" width="4" height="10" fill="#fff"/><rect y="3" width="14" height="4" fill="#fff"/></svg>);
const FlagPT = () => (<svg width="36" height="24" viewBox="0 0 36 24"><rect width="13" height="24" fill="#006600"/><rect x="13" width="23" height="24" fill="#ff0000"/><circle cx="13" cy="12" r="5" fill="#ff0" stroke="#000" strokeWidth="0.3"/><circle cx="11" cy="10" r="1" fill="#003399"/><circle cx="11" cy="14" r="1" fill="#003399"/><circle cx="15" cy="12" r="1" fill="#003399"/><circle cx="13" cy="9" r="0.8" fill="#003399"/><circle cx="10" cy="12" r="0.8" fill="#003399"/></svg>);
const FlagES = () => (<svg width="36" height="24" viewBox="0 0 36 24"><rect width="36" height="6" fill="#c60b1e"/><rect y="6" width="36" height="12" fill="#ffc400"/><rect y="18" width="36" height="6" fill="#c60b1e"/></svg>);
const FlagFR = () => (<svg width="36" height="24" viewBox="0 0 36 24"><rect width="12" height="24" fill="#002395"/><rect x="12" width="12" height="24" fill="#fff"/><rect x="24" width="12" height="24" fill="#ed2939"/></svg>);
const FlagMT = () => (<svg width="36" height="24" viewBox="0 0 36 24"><rect width="18" height="24" fill="#fff"/><rect x="18" width="18" height="24" fill="#cf142b"/></svg>);

const COUNTRY_FLAGS = { IT: FlagIT, GR: FlagGR, PT: FlagPT, ES: FlagES, FR: FlagFR, MT: FlagMT };

const CountryFlag = ({ code }) => {
  const Flag = COUNTRY_FLAGS[code];
  return Flag ? <span style={{display:'inline-flex',alignItems:'center',justifyContent:'center',width:'2.8rem',height:'2rem',borderRadius:3,overflow:'hidden',border:'1px solid rgba(255,255,255,0.2)',flexShrink:0}}><Flag /></span> : <span style={{display:'inline-flex',alignItems:'center',justifyContent:'center',width:'2.6rem',height:'2.6rem',borderRadius:'50%',background:'rgba(184,151,90,0.15)',border:'1px solid rgba(184,151,90,0.35)',fontSize:'0.85rem',fontWeight:600,color:'#e8dfd0',fontFamily:"'Jost',sans-serif"}}>{code}</span>;
};

const CountryFlagLarge = ({ code }) => (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: '4.5rem', height: '4.5rem', borderRadius: '50%',
    background: 'rgba(184,151,90,0.12)', border: '1px solid rgba(184,151,90,0.4)',
    fontSize: '1.4rem', fontWeight: 600, letterSpacing: '0.04em',
    color: '#e8dfd0', fontFamily: "'Jost', sans-serif",
  }}>{code}</span>
);

/* Portal row icons */
const IconClipboard = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"/>
    <rect x="8" y="2" width="8" height="4" rx="1"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="13" y2="16"/>
  </svg>
);
const IconCalendar = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);
const IconChat = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
  </svg>
);
const IconShield = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

/* Quiz icons */
const QuizIcon = ({ type }) => {
  const w = 28, h = 28;
  const style = { width: `${w}px`, height: `${h}px` };
  switch (type) {
    case 'retire': return <svg {...style} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="24" cy="18" r="6"/><line x1="24" y1="6" x2="24" y2="12"/><path d="M4 30h40M8 36c0-8.8 7.2-16 16-16s16 7.2 16 16"/></svg>;
    case 'family': return <svg {...style} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="18" cy="15" r="5"/><path d="M6 38c0-6.6 5.4-12 12-12s12 5.4 12 12"/><circle cx="34" cy="11" r="3"/><path d="M28 30c0-3.3 2.7-6 6-6s6 2.7 6 6"/></svg>;
    case 'study': return <svg {...style} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M4 18L24 8l20 10-20 10L4 18z"/><path d="M4 18v14"/><polyline points="14,28 14,38 24,42 34,38 34,28"/></svg>;
    case 'work': return <svg {...style} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><rect x="6" y="12" width="36" height="24" rx="2"/><line x1="6" y1="30" x2="42" y2="30"/><path d="M2 38h44M14 38l2 4h16l2-4"/></svg>;
    case 'invest': return <svg {...style} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><line x1="6" y1="38" x2="42" y2="38"/><line x1="8" y1="38" x2="8" y2="12"/><polyline points="8,28 16,18 24,24 32,10 42,14"/></svg>;
    case 'eu': return <svg {...style} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"><circle cx="24" cy="24" r="18"/><polygon points="24,6 26.5,16.5 24,14.5 21.5,16.5" fill="currentColor" stroke="none" opacity="0.4"/><polygon points="39,18 32,25.5 41,25.5" fill="currentColor" stroke="none" opacity="0.4"/><polygon points="39,30 32,22.5 41,22.5" fill="currentColor" stroke="none" opacity="0.4"/><polygon points="24,42 26.5,31.5 24,33.5 21.5,31.5" fill="currentColor" stroke="none" opacity="0.4"/><polygon points="9,30 16,22.5 7,22.5" fill="currentColor" stroke="none" opacity="0.4"/><polygon points="9,18 16,25.5 7,25.5" fill="currentColor" stroke="none" opacity="0.4"/></svg>;
    case 'map': return <svg {...style} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><polygon points="4,8 16,4 32,8 44,4 44,40 32,44 16,40 4,44"/><line x1="16" y1="4" x2="16" y2="40"/><line x1="32" y1="8" x2="32" y2="44"/></svg>;
    default: return null;
  }
};


/* ═══════════════════════════════════════════════════════
   COUNTRY DATA
   ═══════════════════════════════════════════════════════ */
const COUNTRIES = {
  italy: {
    code: 'IT', label: 'Southern Europe', name: '<em>Italy</em>',
    bg: 'https://images.unsplash.com/photo-1655685784726-780dd8c609e8?w=1800&q=85',
    tagline: 'La dolce vita awaits — rich culture, world-class food, and a surprisingly accessible path to residency for remote workers, retirees, and investors alike.',
    visas: ['Golden Visa', 'Elective Residency', 'Digital Nomad', 'Study Visa', 'Family Reunification'],
    facts: [
      { icon: '<polyline points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>', label: 'Visa Programmes', value: 'Golden Visa, Elective Residency, Digital Nomad' },
      { icon: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>', label: 'Processing Time', value: 'Typically 3–6 months' },
      { icon: '<line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>', label: 'Min. Income (Elective)', value: '~€31,000 / year' },
      { icon: '<path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>', label: 'Quality of Life', value: 'Exceptional — Mediterranean climate, culture & cuisine' },
    ],
  },
  greece: {
    code: 'GR', label: 'Southeastern Europe', name: '<em>Greece</em>',
    bg: 'https://images.unsplash.com/photo-1667909436291-926243e99cd6?w=1800&q=85',
    tagline: 'Ancient beauty meets modern opportunity. Greece offers one of Europe\'s most attractive Golden Visa programmes and a growing Digital Nomad pathway.',
    visas: ['Golden Visa', 'Digital Nomad', 'Retirement Visa', 'Family Reunification'],
    facts: [
      { icon: '<polyline points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>', label: 'Visa Programmes', value: 'Golden Visa, Digital Nomad, Retirement' },
      { icon: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>', label: 'Processing Time', value: 'Typically 2–4 months' },
      { icon: '<line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>', label: 'Min. Investment (Golden Visa)', value: 'From €250,000 (real estate)' },
      { icon: '<path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>', label: 'Quality of Life', value: '300+ days of sunshine, islands & mainland' },
    ],
  },
  portugal: {
    code: 'PT', label: 'Southwestern Europe', name: '<em>Portugal</em>',
    bg: 'https://images.unsplash.com/photo-1697992253438-7f83ddea2b98?w=1800&q=85',
    tagline: 'One of Europe\'s most welcoming destinations for expats. Portugal\'s NHR tax regime, Digital Nomad visa, and Golden Visa make it a perennial favourite.',
    visas: ['Golden Visa', 'Digital Nomad', 'D7 Passive Income', 'Study Visa', 'NHR Tax Regime'],
    facts: [
      { icon: '<polyline points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>', label: 'Visa Programmes', value: 'Golden Visa, D7, Digital Nomad, NHR' },
      { icon: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>', label: 'Processing Time', value: 'Typically 3–5 months' },
      { icon: '<line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>', label: 'Min. Income (D7)', value: '~€760/month (passive income)' },
      { icon: '<path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>', label: 'Quality of Life', value: 'Affordable, safe, English-friendly' },
    ],
  },
  spain: {
    code: 'ES', label: 'Southwestern Europe', name: '<em>Spain</em>',
    bg: 'https://images.unsplash.com/photo-1640166163440-e1f61340a4b5?w=1800&q=85',
    tagline: 'Vibrant cities, stunning coastlines, and a rich cultural tapestry. Spain\'s Non-Lucrative Visa and new Digital Nomad visa are perfect for retirees and remote workers.',
    visas: ['Non-Lucrative Visa', 'Digital Nomad Visa', 'Study Visa', 'Family Reunification'],
    facts: [
      { icon: '<polyline points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>', label: 'Visa Programmes', value: 'Non-Lucrative, Digital Nomad' },
      { icon: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>', label: 'Processing Time', value: 'Typically 1–3 months' },
      { icon: '<line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>', label: 'Min. Income (NLV)', value: '~€2,400/month' },
      { icon: '<path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>', label: 'Quality of Life', value: 'World-class gastronomy, art & lifestyle' },
    ],
  },
  france: {
    code: 'FR', label: 'Western Europe', name: '<em>France</em>',
    bg: 'https://images.unsplash.com/photo-1689724950888-36a5b490df61?w=1800&q=85',
    tagline: 'Elegance, culture, and joie de vivre. France offers long-stay visas for retirees and a prestigious Golden Visa programme for qualifying investors.',
    visas: ['Golden Visa (Investor)', 'Long-Stay Visa', 'Talent Passport', 'Family Reunification'],
    facts: [
      { icon: '<polyline points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>', label: 'Visa Programmes', value: 'Investor Visa, Long-Stay, Talent Passport' },
      { icon: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>', label: 'Processing Time', value: 'Typically 2–4 months' },
      { icon: '<line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>', label: 'Min. Investment', value: 'From €300,000 (investor route)' },
      { icon: '<path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>', label: 'Quality of Life', value: 'Unmatched arts, cuisine, healthcare' },
    ],
  },
  malta: {
    code: 'MT', label: 'Mediterranean Island', name: '<em>Malta</em>',
    bg: 'https://images.unsplash.com/photo-1669294841689-0ceb34ad40c1?w=1800&q=85',
    tagline: 'A sun-drenched English-speaking island at the heart of the Mediterranean. Malta\'s MPRP programme and retirement residency are among Europe\'s most sought-after.',
    visas: ['Malta Permanent Residency (MPRP)', 'Retirement Programme', 'Global Residence Programme', 'Digital Nomad'],
    facts: [
      { icon: '<polyline points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>', label: 'Visa Programmes', value: 'MPRP, Retirement, Global Residence' },
      { icon: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>', label: 'Processing Time', value: 'Typically 4–6 months' },
      { icon: '<line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>', label: 'Min. Investment (MPRP)', value: 'From €150,000' },
      { icon: '<path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>', label: 'Quality of Life', value: 'English-speaking, EU access, low crime' },
    ],
  },
};

/* ═══════════════════════════════════════════
   COUNTRY MODAL COMPONENT
   ═══════════════════════════════════════════ */
const CountryModal = ({ countryKey, onClose, onOpenQuiz }) => {
  if (!countryKey) return null;
  const d = COUNTRIES[countryKey];
  if (!d) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget || e.target.classList.contains('dv-cm-overlay')) {
      onClose();
    }
  };

  return (
    <div className="dv-country-modal open visible" onClick={handleOverlayClick}>
      <div className="dv-cm-bg" style={{ backgroundImage: `url('${d.bg}')` }} />
      <div className="dv-cm-overlay" />
      <button className="dv-cm-close" onClick={onClose}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <div className="dv-cm-content">
        <div className="dv-cm-left">
          <CountryFlagLarge code={d.code} />
          <span className="dv-cm-country-label">{d.label}</span>
          <div className="dv-cm-country-name" dangerouslySetInnerHTML={{ __html: d.name }} />
          <p className="dv-cm-tagline">{d.tagline}</p>
          <div className="dv-cm-visa-chips">
            {d.visas.map((v, i) => <span key={i} className="dv-cm-chip">{v}</span>)}
          </div>
        </div>
        <div className="dv-cm-right">
          <div className="dv-cm-facts">
            {d.facts.map((f, i) => (
              <div key={i} className="dv-cm-fact">
                <div className="dv-cm-fact-icon">
                  <svg width="18" height="18" fill="none" stroke="#b8975a" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" dangerouslySetInnerHTML={{ __html: f.icon }} />
                </div>
                <div className="dv-cm-fact-info">
                  <div className="dv-cm-fact-label">{f.label}</div>
                  <div className="dv-cm-fact-value">{f.value}</div>
                </div>
              </div>
            ))}
          </div>
          <button className="dv-cm-cta" onClick={() => { onClose(); onOpenQuiz(); }}>
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
            Start My Visa Assessment
          </button>
          <a href="#contact" className="dv-cm-cta-secondary" onClick={onClose}>Speak to an advisor →</a>
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════
   MAIN HOMEPAGE COMPONENT
   ═══════════════════════════════════════════ */
const HomePage = () => {
  const { language, availableLanguages, addLanguagePrefix } = useLanguage();
  const location = useLocation();
  const [countryModal, setCountryModal] = useState(null);
  const homeRef = useRef(null);

  const pathParts = location.pathname.split('/').filter(Boolean);
  const urlLang = pathParts[0];
  const lang = availableLanguages.includes(urlLang) ? urlLang : (language || 'en');
  const { t } = useTranslations('home', lang);

  // ── Hash scroll ──
  useEffect(() => {
    const hash = location.hash?.replace('#', '');
    if (hash) {
      const el = document.getElementById(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
    }
  }, [location.pathname, location.hash]);

  // ── GSAP Scroll Animations (optimizat — fara parallax pe hero) ──
  useEffect(() => {
    const ctx = gsap.context(() => {
      /* Scroll progress bar — throttled via RAF pentru performanță */
      let rafId;
      const progressBar = document.getElementById('scrollProgress');
      const st = ScrollTrigger.create({
        start: 0, end: 'max',
        onUpdate: (self) => {
          if (rafId) return;
          rafId = requestAnimationFrame(() => {
            if (progressBar) progressBar.style.width = (self.progress * 100) + '%';
            rafId = null;
          });
        },
      });

      /* Hero entrance — doar la încărcare, fără parallax la scroll */
      const heroTl = gsap.timeline({ delay: 0.3 });
      heroTl
        .from('#text-0 .dv-hero-eyebrow', { y: 30, opacity: 0, duration: 0.8, ease: 'power3.out' })
        .from('#text-0 h1', { y: 40, opacity: 0, duration: 0.9, ease: 'power3.out' }, '-=0.6')
        .from('#text-0 .dv-hero-sub', { y: 20, opacity: 0, duration: 0.7, ease: 'power3.out' }, '-=0.5')
        .from('#text-0 .dv-hero-actions', { y: 15, opacity: 0, duration: 0.6, ease: 'power3.out' }, '-=0.4')
        .from('.dv-platform-badge', { y: 15, opacity: 0, duration: 0.5, ease: 'power3.out' }, '-=0.3');

      /* Stat strip entrance */
      ScrollTrigger.create({
        trigger: '.dv-stat-strip', start: 'top 85%', once: true,
        onEnter: () => {
          gsap.from('.dv-stat-item', { y: 30, opacity: 0, stagger: 0.12, duration: 0.7, ease: 'power2.out' });
          gsap.from('.dv-stat-divider', { scaleY: 0, opacity: 0, stagger: 0.15, duration: 0.5, ease: 'power2.out', delay: 0.1 });
          const statNums = document.querySelectorAll('.dv-stat-num');
          gsap.to({ val: 0 }, { val: 6, duration: 1.5, ease: 'power2.out', delay: 0.3,
            onUpdate: function() { if (statNums[0]) statNums[0].textContent = Math.round(this.targets()[0].val); } });
          gsap.to({ val: 0 }, { val: 98, duration: 1.5, ease: 'power2.out', delay: 0.3,
            onUpdate: function() { if (statNums[1]) statNums[1].textContent = Math.round(this.targets()[0].val) + '%'; } });
        },
      });

      /* Intent section entrance */
      gsap.from('.dv-intent-header .dv-section-label, .dv-intent-header .dv-section-title, .dv-intent-header .dv-section-lead', {
        y: 20, opacity: 0, stagger: 0.1, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-intent-header', start: 'top 80%', once: true },
      });
      gsap.from('.dv-intent-card', {
        y: 40, opacity: 0, scale: 0.96,
        stagger: { amount: 0.4 }, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-intent-grid', start: 'top 80%', once: true },
      });

      /* Countries entrance */
      gsap.from('.dv-countries-header .dv-section-label, .dv-countries-header .dv-section-title, .dv-countries-header .dv-section-lead', {
        y: 20, opacity: 0, stagger: 0.1, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-countries-header', start: 'top 80%', once: true },
      });
      gsap.from('.dv-country-card', {
        y: 50, opacity: 0, scale: 0.92,
        stagger: { amount: 0.5 }, duration: 0.8, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-countries-grid', start: 'top 85%', once: true },
      });


      /* Platform entrance */
      gsap.from('.dv-platform-left', {
        x: -30, opacity: 0, duration: 0.8, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-platform-section', start: 'top 75%', once: true },
      });
      gsap.from('.dv-platform-right', {
        x: 30, opacity: 0, duration: 0.8, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-platform-section', start: 'top 75%', once: true },
      });
      gsap.from('.dv-portal-row', {
        y: 15, opacity: 0, stagger: 0.06, duration: 0.5, ease: 'power2.out', delay: 0.2,
        scrollTrigger: { trigger: '.dv-platform-right', start: 'top 70%', once: true },
      });
      gsap.from('.dv-platform-perk', {
        y: 15, opacity: 0, stagger: 0.08, duration: 0.5, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-platform-perks', start: 'top 80%', once: true },
      });

      /* Timeline fill — singurul scrub animat (lightweight) */
      gsap.to('#timelineFill', {
        height: '100%', ease: 'none',
        scrollTrigger: { trigger: '.dv-timeline-container', start: 'top 65%', end: 'bottom 55%', scrub: 0.5 },
      });
      document.querySelectorAll('.dv-timeline-step-content').forEach((el, i) => {
        gsap.from(el, {
          x: i % 2 === 0 ? -30 : 30, opacity: 0, duration: 0.7, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 85%', once: true },
        });
      });
      gsap.utils.toArray('.dv-timeline-icon').forEach(icon => {
        gsap.from(icon, {
          scale: 0, opacity: 0, duration: 0.5, ease: 'back.out(1.4)',
          scrollTrigger: { trigger: icon, start: 'top 88%', once: true },
        });
      });

      /* Assessment entrance */
      gsap.from('.dv-assessment-visual', {
        x: -30, opacity: 0, duration: 0.8, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-assessment-section', start: 'top 75%', once: true },
      });
      gsap.from('.dv-assessment-card', {
        x: 30, opacity: 0, duration: 0.8, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-assessment-section', start: 'top 75%', once: true },
      });

      /* Contact entrance */
      gsap.from('.dv-calendly-banner', {
        y: 30, opacity: 0, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-contact-section', start: 'top 80%', once: true },
      });
      gsap.from('.dv-contact-text', {
        x: -30, opacity: 0, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-contact-cols', start: 'top 80%', once: true },
      });
      gsap.from('.dv-contact-form', {
        x: 30, opacity: 0, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: '.dv-contact-cols', start: 'top 80%', once: true },
      });
    }, homeRef);

    return () => ctx.revert();
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && countryModal) setCountryModal(null);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [countryModal]);

  const openQuiz = useCallback(() => {
    // Deschide quiz-ul real din subdomeniu (populat din baza de date)
    const base = contacts.quizUrl || 'http://localhost:3000';
    const params = new URLSearchParams({ quiz: contacts.defaultQuizSlug || 'default-quiz' });
    window.open(`${base.replace(/\/$/, '')}?${params.toString()}`, '_blank', 'noopener,noreferrer');
  }, []);
  const openCountry = useCallback((key) => { setCountryModal(key); document.body.classList.add('modal-open'); }, []);
  const closeCountry = useCallback(() => { setCountryModal(null); document.body.classList.remove('modal-open'); }, []);

  const intentCards = [
    { slug: 'live-retire-abroad', Icon: IconSunset, title: t('iWantTo.retire', 'Live & Retire Abroad'), desc: t('iWantTo.retireTagline', 'Secure your retirement in the EU with Elective Residency and Golden Visa programmes designed for passive-income holders.') },
    { slug: 'join-family', Icon: IconFamily, title: t('iWantTo.joinFamily', 'Join Family'), desc: t('iWantTo.joinFamilyTagline', 'Reunite with loved ones already residing in Europe through streamlined family reunification visa pathways.') },
    { slug: 'study-abroad', Icon: IconGraduation, title: t('iWantTo.studyAbroad', 'Study Abroad'), desc: t('iWantTo.studyAbroadTagline', 'Access world-class European universities with the right student visa and residence permit for your academic journey.') },
    { slug: 'work-remotely', Icon: IconLaptop, title: t('iWantTo.workRemotely', 'Work Remotely'), desc: t('iWantTo.workRemotelyTagline', 'Live in Europe while working for a non-EU employer. Digital Nomad visas available across Italy, Greece, Portugal, and Spain.') },
    { slug: 'invest', Icon: IconChart, title: t('iWantTo.investRelocate', 'Invest'), desc: t('iWantTo.investRelocateTagline', 'Golden Visa programmes across Italy, Greece, Portugal, France, and Malta — residency through qualifying investment.') },
    { slug: 'eu-citizens', Icon: IconEU, title: t('iWantTo.euCitizens', 'EU Citizens & Family Members'), desc: t('iWantTo.euCitizensTagline', 'Navigate your rights to free movement and residence registration across EU member states with expert guidance.') },
  ];

  const countryCards = [
    { key: 'italy', code: 'IT', name: 'Italy', bg: 'https://images.unsplash.com/photo-1655685784726-780dd8c609e8?w=900&q=85' },
    { key: 'greece', code: 'GR', name: 'Greece', bg: 'https://images.unsplash.com/photo-1667909436291-926243e99cd6?w=900&q=85' },
    { key: 'portugal', code: 'PT', name: 'Portugal', bg: 'https://images.unsplash.com/photo-1697992253438-7f83ddea2b98?w=900&q=85' },
    { key: 'spain', code: 'ES', name: 'Spain', bg: 'https://images.unsplash.com/photo-1640166163440-e1f61340a4b5?w=900&q=85' },
    { key: 'france', code: 'FR', name: 'France', bg: 'https://images.unsplash.com/photo-1689724950888-36a5b490df61?w=900&q=85' },
    { key: 'malta', code: 'MT', name: 'Malta', bg: 'https://images.unsplash.com/photo-1669294841689-0ceb34ad40c1?w=900&q=85' },
  ];

  return (
    <div className="home-delvante" ref={homeRef}>
      <div className="dv-scroll-progress" id="scrollProgress" />

      {/* ═══════════ HERO ═══════════ */}
      <HeroSection onOpenQuiz={openQuiz} t={t} />

      {/* ═══════════ STAT STRIP ═══════════ */}
      <div className="dv-stat-strip">
        <div className="dv-stat-inner">
          <div className="dv-stat-item">
            <div className="dv-stat-num">6</div>
            <div className="dv-stat-label">{t('stats.destinationsLabel', 'EU Destinations')}</div>
            <div className="dv-stat-growing">{t('stats.destinationsGrowing', 'and growing')}</div>
          </div>
          <div className="dv-stat-divider" />
          <div className="dv-stat-item">
            <div className="dv-stat-num">98%</div>
            <div className="dv-stat-label">{t('stats.approvalRateLabel', 'Approval Rate')}</div>
          </div>
          <div className="dv-stat-divider" />
          <div className="dv-stat-item">
            <div className="dv-stat-num">1:1</div>
            <div className="dv-stat-label">{t('stats.caseManagersLabel', 'Personal Case Managers')}</div>
          </div>
        </div>
      </div>

      <div className="dv-section-break-top" />

      {/* ═══════════ I WANT TO... ═══════════ */}
      <section className="dv-intent-section" id="intent">
        <div className="dv-intent-header">
          <span className="dv-section-label">{t('iWantTo.tagline', 'Find Your Path')}</span>
          <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
            <h2 className="dv-section-title"><strong>{t('iWantTo.title', 'I WANT TO')}</strong></h2>
            <p className="dv-section-lead">{t('iWantTo.subtitle', 'Whatever your goal, Delvante has a dedicated visa pathway designed to get you there.')}</p>
          </div>
        </div>
        <div className="dv-intent-grid">
          {intentCards.map((item, i) => (
            <a href={`/visa-pathways/${item.slug}`} key={i} className="dv-intent-card" onClick={(e) => { e.preventDefault(); window.location.href = addLanguagePrefix(`/visa-pathways/${item.slug}`); }}>
              <span className="dv-intent-icon"><item.Icon /></span>
              <div className="dv-intent-title">{item.title}</div>
              <p className="dv-intent-desc">{item.desc}</p>
              <span className="dv-intent-arrow">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/></svg>
              </span>
            </a>
          ))}
        </div>
      </section>

      <div className="dv-gold-rule-sep">
        <div className="dv-gold-rule-line" />
      </div>

      {/* ═══════════ I WANT TO MOVE TO... ═══════════ */}
      <section className="dv-countries-section" style={{paddingBottom:'3rem'}} id="countries">
        <div style={{padding:'6.5rem 0 0.5rem',textAlign:'center'}}>
          <span className="dv-section-label">{t('iWantToMove.tagline', 'Choose Your Destination')}</span>
          <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
            <h2 className="dv-section-title"><strong>{t('iWantToMove.title', 'I WANT TO MOVE TO…')}</strong></h2>
            <p className="dv-section-lead">{t('iWantToMove.subtitle', 'Six EU destinations. One trusted partner to take you there.')}</p>
          </div>
        </div>
        <div className="dv-countries-grid">
          {countryCards.map((c) => (
            <div key={c.key} style={{position:'relative',height:420,overflow:'hidden',cursor:'pointer',transition:'transform 0.4s ease,box-shadow 0.4s ease'}}
              className="dv-country-card-hover"
              onClick={() => window.location.href = addLanguagePrefix ? addLanguagePrefix(`/country/${c.key}`) : `/${lang}/country/${c.key}`}>
              <div style={{position:'absolute',inset:0,backgroundImage:`url('${c.bg}')`,backgroundSize:'cover',backgroundPosition:'center',backgroundColor:'#0a1622',transition:'transform 0.8s ease,filter 0.5s ease',filter:'brightness(0.52)'}} className="dv-country-card-bg-hover" />
              <div style={{position:'absolute',inset:0,background:'linear-gradient(0deg,rgba(8,16,26,0.92) 0%,rgba(8,16,26,0.18) 55%,rgba(8,16,26,0.04) 100%)'}} />
              <div style={{position:'absolute',bottom:0,left:0,right:0,padding:'2rem',zIndex:2,display:'flex',alignItems:'center',gap:'0.8rem'}}>
                <CountryFlag code={c.code} />
                <div style={{fontFamily:"'Cormorant Garamond',serif",fontWeight:400,fontSize:'2rem',color:'var(--white)',lineHeight:1}}>{c.name}</div>
              </div>
            </div>
          ))}
        </div>
        <style>{`
          .dv-country-card-hover:hover{transform:translateY(-6px)!important;box-shadow:0 24px 48px rgba(0,0,0,0.3)!important;z-index:5}
          .dv-country-card-hover:hover .dv-country-card-bg-hover{transform:scale(1.07);filter:brightness(0.68)}
        `}</style>
      </section>

      <div className="dv-section-break-countries-platform" />

      {/* ═══════════ MEMBERS PLATFORM ═══════════ */}
      <section className="dv-platform-section">
        <div className="dv-platform-section-inner">
          <div className="dv-platform-left">
            <span className="dv-section-label">{t('platform.tagline', 'Members-Only Access')}</span>
            <h2 className="dv-section-title">{t('platform.title', 'Your case,')}<br /><em>{t('platform.highlight', 'in your hands.')}</em></h2>
            <p className="dv-section-lead">{t('platform.subtitle', 'Every Delvante client receives private access to our secure digital platform — purpose-built for the immigration journey.')}</p>
            <div className="dv-platform-perks">
              {[
                { num: '01', text: <><strong>{t('platform.perk1.title', 'Secure document upload')}</strong> — {t('platform.perk1.desc', 'submit passports, financials, and records without ever sending an email.')}</> },
                { num: '02', text: <><strong>{t('platform.perk2.title', 'Live case status tracking')}</strong> — {t('platform.perk2.desc', 'see exactly where your application stands at every stage, in real time.')}</> },
                { num: '03', text: <><strong>{t('platform.perk3.title', 'Direct messaging with your case manager')}</strong> — {t('platform.perk3.desc', 'answers from a real person, not a bot, never a queue.')}</> },
                { num: '04', text: <><strong>{t('platform.perk4.title', 'Milestone notifications')}</strong> — {t('platform.perk4.desc', 'know what\'s needed and when, automatically.')}</> },
              ].map((p, i) => (
                <div key={i} className="dv-platform-perk">
                  <div className="dv-perk-num">{p.num}</div>
                  <p className="dv-perk-text">{p.text}</p>
                </div>
              ))}
            </div>
            <Link to={addLanguagePrefix('/login')} className="dv-platform-cta-btn">
              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
              {t('platform.cta', 'Login to Platform')}
            </Link>
          </div>
          <div className="dv-platform-right">
            <div>
              <div className="dv-portal-header">
                <div className="dv-portal-logo">
                  <div className="dv-portal-logo-icon"><svg viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg></div>
                  <span className="dv-portal-logo-name">{t('platform.portalTitle', 'Delvante Members Portal')}</span>
                </div>
                <div className="dv-portal-sub">{t('platform.portalSub', 'Secure Client Area')}</div>
              </div>
              <div className="dv-portal-section-title">{t('platform.sectionTitle', 'Application Overview')}</div>
              <div className="dv-portal-rows">
                <div className="dv-portal-row">
                  <div className="dv-portal-row-icon amber"><IconClipboard /></div>
                  <div className="dv-portal-row-info"><div className="dv-portal-row-label">{t('platform.activeCase', 'Active Case')}</div><div className="dv-portal-row-value">{t('platform.demoCase', 'Italy — Elective Residency Visa')}</div></div>
                  <span className="dv-portal-status dv-ps-amber">{t('platform.inReview', 'In Review')}</span>
                </div>
                <div className="dv-portal-row">
                  <div className="dv-portal-row-icon blue"><IconCalendar /></div>
                  <div className="dv-portal-row-info"><div className="dv-portal-row-label">{t('platform.nextMilestone', 'Next Milestone')}</div><div className="dv-portal-row-value">{t('platform.demoMilestone', 'Consulate Appointment — 14 May')}</div></div>
                  <span className="dv-portal-status dv-ps-blue">{t('platform.upcoming', 'Upcoming')}</span>
                </div>
                <div className="dv-portal-row">
                  <div className="dv-portal-row-icon green"><IconChat /></div>
                  <div className="dv-portal-row-info"><div className="dv-portal-row-label">{t('platform.caseManager', 'Case Manager')}</div><div className="dv-portal-row-value">{t('platform.demoAdvisor', 'Your dedicated advisor — Online')}</div></div>
                  <span className="dv-portal-status dv-ps-green">{t('platform.available', 'Available')}</span>
                </div>
              </div>
              <div className="dv-portal-section-title">{t('platform.docChecklist', 'Document Checklist')}</div>
              <div className="dv-portal-doc-list">
                {[
                  { name: t('platform.docPassport', 'Valid Passport Copy'), done: true },
                  { name: t('platform.docIncome', 'Proof of Income / Pension'), done: true },
                  { name: t('platform.docBank', 'Bank Statements (3 months)'), done: true },
                  { name: t('platform.docInsurance', 'Health Insurance Certificate'), done: false },
                ].map((doc, i) => (
                  <div key={i} className="dv-portal-doc">
                    <span className="dv-portal-doc-name">{doc.name}</span>
                    <div className={`dv-portal-doc-check ${doc.done ? 'done' : 'pending'}`}>
                      {doc.done && <svg viewBox="0 0 10 10"><polyline points="2,5 4,7.5 8,2.5"/></svg>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="dv-portal-footer">
              <div className="dv-portal-security">
                <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                {t('platform.security', '256-bit encrypted')}
              </div>
              <Link to={addLanguagePrefix('/login')} className="dv-portal-login-link">{t('platform.accessPortal', 'Access Portal')} →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════ COUNTRY MODAL ═══════════ */}
      {countryModal && (
        <CountryModal countryKey={countryModal} onClose={closeCountry} onOpenQuiz={openQuiz} />
      )}

      {/* ═══════════ TIMELINE ═══════════ */}
      <section className="dv-timeline-section" id="how">
        <div className="dv-timeline-header">
          <span className="dv-section-label">{t('howItWorks.tagline', 'Our Process')}</span>
          <h2 className="dv-section-title">{t('howItWorks.title', 'How')} <em>{t('howItWorks.highlight', 'Delvante Global')}</em> {t('howItWorks.title2', 'works')}</h2>
          <p className="dv-section-lead">{t('howItWorks.subtitle', 'Five clear steps from first conversation to new address — supported at every stage through our expert team and your private Members Platform.')}</p>
        </div>
        <div className="dv-timeline-container">
          <div className="dv-timeline-line" />
          <div className="dv-timeline-line-fill" id="timelineFill" />

          <div className="dv-timeline-step">
            <div className="dv-timeline-step-content">
              <span className="dv-timeline-step-label">{t("howItWorks.step1.label", "Step One")}</span>
              <h3 className="dv-timeline-step-title">{t("howItWorks.step1.title", "Have Your Consultation")}</h3>
              <p className="dv-timeline-step-desc">{t("howItWorks.step1.desc", "Book a one-on-one video consultation with a Delvante advisor. We take time to understand your goals, lifestyle, and circumstances — no templates, no rushing.")}</p>
            </div>
            <div className="dv-timeline-node">
              <div className="dv-timeline-icon"><span className="dv-step-number">1</span>
                <svg viewBox="0 0 48 48"><circle cx="17" cy="14" r="6" strokeWidth="1.4"/><path d="M5 36c0-6.627 5.373-12 12-12s12 5.373 12 12" strokeWidth="1.4"/><rect x="28" y="8" width="16" height="12" rx="3" strokeWidth="1.4"/><path d="M32 20l-3 4" strokeWidth="1.4"/><line x1="31" y1="13" x2="40" y2="13" strokeWidth="1.4"/><line x1="31" y1="16" x2="38" y2="16" strokeWidth="1.4"/></svg>
              </div>
            </div>
            <div className="dv-timeline-step-ghost" />
          </div>

          <div className="dv-timeline-step">
            <div className="dv-timeline-step-ghost" />
            <div className="dv-timeline-node">
              <div className="dv-timeline-icon"><span className="dv-step-number">2</span>
                <svg viewBox="0 0 48 48"><circle cx="24" cy="24" r="16" strokeWidth="1.4"/><circle cx="24" cy="24" r="3" strokeWidth="1.4"/><polygon points="24,8 21,24 24,21 27,24" strokeWidth="1" style={{ fill: 'rgba(232,223,208,0.8)', stroke: '#e8dfd0', strokeWidth: 0.5 }} /><polygon points="24,40 21,24 24,27 27,24" strokeWidth="1" style={{ fill: 'rgba(232,223,208,0.2)', stroke: '#e8dfd0', strokeWidth: 0.5 }} /></svg>
              </div>
            </div>
            <div className="dv-timeline-step-content">
              <span className="dv-timeline-step-label">{t("howItWorks.step2.label", "Step Two")}</span>
              <h3 className="dv-timeline-step-title">{t("howItWorks.step2.title", "Determine the Best Visa Pathway")}</h3>
              <p className="dv-timeline-step-desc">{t("howItWorks.step2.desc", "Based on your profile, we map the optimal visa route.")}</p>
            </div>
          </div>

          <div className="dv-timeline-step">
            <div className="dv-timeline-step-content">
              <span className="dv-timeline-step-label">{t("howItWorks.step3.label", "Step Three")}</span>
              <h3 className="dv-timeline-step-title">{t("howItWorks.step3.title", "Access Your Members Platform")}</h3>
              <p className="dv-timeline-step-desc">{t("howItWorks.step3.desc", "You receive private login credentials to the Delvante Members Portal.")}</p>
              <span className="dv-timeline-step-platform">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
                Secure Members-Only Platform
              </span>
            </div>
            <div className="dv-timeline-node">
              <div className="dv-timeline-icon gold-icon"><span className="dv-step-number">3</span>
                <svg viewBox="0 0 48 48"><path d="M24 6L8 13v12c0 9 7 16.5 16 19 9-2.5 16-10 16-19V13L24 6z" strokeWidth="1.4"/><rect x="18" y="24" width="12" height="10" rx="2" strokeWidth="1.4" style={{ fill: 'var(--navy)', stroke: 'var(--navy)' }}/><path d="M20 24v-4a4 4 0 018 0v4" strokeWidth="1.4"/><circle cx="24" cy="28" r="1.5" style={{ fill: 'var(--gold)', stroke: 'none' }}/><line x1="24" y1="29.5" x2="24" y2="32" strokeWidth="1.4" style={{ stroke: 'var(--gold)' }}/></svg>
              </div>
            </div>
            <div className="dv-timeline-step-ghost" />
          </div>

          <div className="dv-timeline-step">
            <div className="dv-timeline-step-ghost" />
            <div className="dv-timeline-node">
              <div className="dv-timeline-icon"><span className="dv-step-number">4</span>
                <svg viewBox="0 0 48 48"><circle cx="24" cy="14" r="7" strokeWidth="1.4"/><path d="M12 40c0-6.627 5.373-12 12-12s12 5.373 12 12" strokeWidth="1.4"/><polygon points="38,6 39.5,10 44,10 40.5,12.5 42,17 38,14.5 34,17 35.5,12.5 32,10 36.5,10" strokeWidth="0.8" style={{ fill: 'rgba(232,223,208,0.15)', stroke: '#e8dfd0', strokeWidth: 0.8 }}/></svg>
              </div>
            </div>
            <div className="dv-timeline-step-content">
              <span className="dv-timeline-step-label">{t("howItWorks.step4.label", "Step Four")}</span>
              <h3 className="dv-timeline-step-title">{t("howItWorks.step4.title", "Your Personal Case Manager")}</h3>
              <p className="dv-timeline-step-desc">{t("howItWorks.step4.desc", "A dedicated case manager is assigned to you personally.")}</p>
            </div>
          </div>

          <div className="dv-timeline-step">
            <div className="dv-timeline-step-content">
              <span className="dv-timeline-step-label">{t("howItWorks.step5.label", "Step Five")}</span>
              <h3 className="dv-timeline-step-title">{t("howItWorks.step5.title", "Get Your Visa. Start Your Life.")}</h3>
              <p className="dv-timeline-step-desc">Your visa is approved. Your documents are in order. All that's left is to move. We celebrate with you — and remain available for any post-arrival questions as you begin your new chapter in Europe.</p>
            </div>
            <div className="dv-timeline-node">
              <div className="dv-timeline-icon gold-icon"><span className="dv-step-number">5</span>
                <svg viewBox="0 0 48 48"><path d="M8 24L24 10l16 14" strokeWidth="1.4" strokeLinejoin="round"/><path d="M12 21v16h10v-9h4v9h10V21" strokeWidth="1.4" strokeLinejoin="round"/><rect x="21" y="31" width="6" height="6" rx="0.5" strokeWidth="1.2"/><circle cx="7" cy="12" r="1.2" style={{ fill: '#0d1e2e', stroke: 'none' }}/><circle cx="41" cy="11" r="1.2" style={{ fill: '#0d1e2e', stroke: 'none' }}/></svg>
              </div>
            </div>
            <div className="dv-timeline-step-ghost" />
          </div>
        </div>
      </section>

      {/* ═══════════ ASSESSMENT ═══════════ */}
      <section className="dv-assessment-section">
        <div className="dv-assessment-bg-num">?</div>
        <div className="dv-assessment-inner">
          <div className="dv-assessment-visual">
            <span className="dv-assessment-eyebrow">{t('assessment.tagline', 'Free & Takes a Few Minutes')}</span>
            <h2 className="dv-assessment-headline">{t('assessment.title', 'Not sure')}<br /><em>{t('assessment.highlight', 'where to start?')}</em></h2>
            <p className="dv-assessment-body">{t('assessment.body', 'Answer a few questions about your situation and we\'ll instantly match you with the visa types and countries that fit your profile. Then, if you want to go deeper, book a personalised consultation with one of our immigration experts.')}</p>
            <div className="dv-assessment-promise-list">
              {[
                'Matched with compatible visa types for your situation',
                'Countries shortlisted based on your goals and profile',
                'Option to book a 1:1 consultation with an expert to go further',
                'No commitment — completely free',
              ].map((text, i) => (
                <div key={i} className="dv-assessment-promise">
                  <div className="dv-assessment-promise-icon">
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  {text}
                </div>
              ))}
            </div>
          </div>
          <div className="dv-assessment-card">
            <span className="dv-assessment-card-label">{t('assessment.cardLabel', 'Your Visa Assessment')}</span>
            <div className="dv-assessment-card-title">{t('assessment.cardTitle', 'Find your match')}</div>
            <div className="dv-assessment-card-sub">{t('assessment.cardSub', 'Tell us about your situation and we\'ll show you which visa pathways and destinations are the right fit — instantly. Want to go further? A personal consultation with one of our experts is just one step away.')}</div>
            <div className="dv-assessment-steps-row">
              <div className="dv-assessment-step-box"><div className="dv-assessment-step-num">01</div><div className="dv-assessment-step-lbl">{t('assessment.step1', 'Your Profile')}</div></div>
              <div className="dv-assessment-step-box"><div className="dv-assessment-step-num">02</div><div className="dv-assessment-step-lbl">{t('assessment.step2', 'Your Match')}</div></div>
              <div className="dv-assessment-step-box"><div className="dv-assessment-step-num">03</div><div className="dv-assessment-step-lbl">{t('assessment.step3', 'Go Deeper')}</div></div>
            </div>
            <button className="dv-btn-gold-full" onClick={openQuiz}>
              <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
              {t('assessment.cta', 'Start Free Assessment')}
            </button>
            <a href="#contact" className="dv-btn-outline-light">{t('assessment.ctaSecondary', 'Book a consultation with an expert')} →</a>
          </div>
        </div>
      </section>

      {/* ═══════════ CONTACT ═══════════ */}
      <section className="dv-contact-section" id="contact">
        <div className="dv-contact-inner">
          <div className="dv-calendly-banner">
            <div className="dv-calendly-banner-text">
              <span className="dv-calendly-banner-eyebrow">{t('contact.calendlyEyebrow', 'Book a Call')}</span>
              <div className="dv-calendly-banner-title">{t('contact.calendlyTitle', 'Prefer to talk it through first?')}</div>
              <p className="dv-calendly-banner-desc">{t('contact.calendlyDesc', 'Schedule a')} <strong>{t('contact.calendlyDescBold', 'free 30-minute consultation')}</strong> {t('contact.calendlyDesc2', 'with one of our advisors — no commitment, no pressure. We\'ll listen to your situation and point you in the right direction.')}</p>
              <div className="dv-calendly-free-tag">{t('contact.calendlyFreeTag', 'Free & no obligation')}</div>
            </div>
            <a href="https://calendly.com/delvanteglobal" target="_blank" rel="noopener noreferrer" className="dv-calendly-btn">
              <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              {t('contact.bookFreeCall', 'Book Free Call')}
            </a>
          </div>

          <div className="dv-contact-cols">
            <div className="dv-contact-text">
              <span className="dv-section-label">{t('contact.getInTouch', 'Get In Touch')}</span>
              <h2 className="dv-section-title">{t('contact.title', 'Ready to take')} <em>{t('contact.highlight', 'the next step?')}</em></h2>
              <p className="dv-section-lead">{t('contact.subtitle', 'Whether you\'re ready to apply or just want to explore your options, our team is here. Leave us a message and we\'ll be in touch within one business day.')}</p>
              <div className="dv-contact-info">
                <div className="dv-contact-info-item">
                  <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                  info@delvanteglobal.com
                </div>
                <div className="dv-contact-info-item">
                  <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
                  Secure messaging via Members Platform
                </div>
                <div className="dv-contact-info-item">
                  <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  Response within 1 business day
                </div>
              </div>
            </div>
            <div className="dv-contact-form">
              <div className="dv-form-row">
                <div className="dv-form-group"><label>{t('contact.firstName', 'First Name')}</label><input type="text" placeholder="Maria" /></div>
                <div className="dv-form-group"><label>{t('contact.lastName', 'Last Name')}</label><input type="text" placeholder="Costa" /></div>
              </div>
              <div className="dv-form-group"><label>{t('contact.emailLabel', 'Email Address')}</label><input type="email" placeholder="maria@example.com" /></div>
              <div className="dv-form-group">
                <label>{t('contact.interestLabel', 'I\'m Interested In')}</label>
                <select defaultValue="">
                  <option value="">{t('contact.selectPathway', 'Select a pathway…')}</option>
                  <option>Live & Retire Abroad</option>
                  <option>Join Family</option>
                  <option>Study Abroad</option>
                  <option>Work Remotely / Digital Nomad</option>
                  <option>Invest / Golden Visa</option>
                  <option>EU Citizens & Family Members</option>
                </select>
              </div>
              <div className="dv-form-group">
                <label>{t('contact.destinationLabel', 'Preferred Destination')}</label>
                <select defaultValue="">
                  <option value="">{t('contact.selectCountry', 'Select a country…')}</option>
                  <option>Italy</option><option>Greece</option><option>Portugal</option><option>Spain</option><option>France</option><option>Malta</option>
                  <option>{t('contact.notSure', 'Not sure yet')}</option>
                </select>
              </div>
              <div className="dv-form-group"><label>{t('contact.notesLabel', 'Your Message')}</label><textarea rows="4" placeholder={t('contact.notesPlaceholder', 'Tell us briefly about your situation…')}></textarea></div>
              <button className="dv-form-submit">{t('contact.sendMessage', 'Send Message')} →</button>
              <p className="dv-form-note">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ display: 'inline', verticalAlign: 'middle', marginRight: '0.3rem' }}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                Your information is private and secure. We never share your data.
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default HomePage;
